import React from 'react';
import { Badge, Modal } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';

const ServerErrorPopup = (props) => {
  return (
    <Modal
      centered
      size="lg"
      show={true}
      onHide={() => props.onClose()}
      closeButton
    >
      <Modal.Body>
        <h4>
          <Badge bg="light" text="danger">
            {props.mainErr}
          </Badge>
        </h4>
        <h6 style={{marginLeft:'10px'}}>Please contact administrator or try again later</h6>
        <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => props.onClose()}
          >
            Close
          </StyledButton>
        </ButtonContainer>
      </Modal.Body>
    </Modal>
  );
};

export default ServerErrorPopup;
